import { createContext } from "react";

const TimelineContext = createContext(undefined as any);

export default TimelineContext;
